import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import fetchWithAuth from '@/utils/fetchWithAuth';
import FloatingSaveButton from '@/components/FloatingSaveButton.vue';
import { computeExpiresAt, getTokenStatus } from '@/utils/tokenExpiration';
export default {
  components: {
    FloatingSaveButton
  },
  data() {
    return {
      authSettings: {
        user: {},
        admin: {}
      },
      uploadSettings: {
        moderate: {},
        ipQuery: {
          enabled: false,
          channel: 'customApi',
          customApi: {
            url: '',
            params: [{
              key: 'ip',
              value: '{ip}'
            }],
            responseFields: []
          }
        }
      },
      accessSettings: {},
      apiTokens: [],
      // API Token列表
      // 加载状态
      loading: true,
      tokenLoading: false,
      // 修改密码相关
      oriUserPassword: '',
      // 原上传密码
      oriAdminPassword: '',
      // 原管理端密码

      showUserPassConfirm: false,
      // 显示用户密码确认框
      showAdminPassConfirm: false,
      // 显示管理密码确认框
      clearUserPassword: false,
      // 清除用户密码开关
      clearAdminPassword: false,
      // 清除管理密码开关

      // Token对话框相关
      showCreateTokenDialog: false,
      showEditTokenDialog: false,
      showTokenResultDialog: false,
      timeUnitOptions: [{
        labelKey: 'sysSecurity.timeUnitSeconds',
        value: 's'
      }, {
        labelKey: 'sysSecurity.timeUnitMinutes',
        value: 'm'
      }, {
        labelKey: 'sysSecurity.timeUnitHours',
        value: 'h'
      }, {
        labelKey: 'sysSecurity.timeUnitDays',
        value: 'd'
      }, {
        labelKey: 'sysSecurity.timeUnitMonths',
        value: 'M'
      }, {
        labelKey: 'sysSecurity.timeUnitYears',
        value: 'Y'
      }],
      newToken: {
        name: '',
        owner: '',
        permissions: [],
        neverExpire: true,
        expirationValue: 1,
        expirationUnit: 'd',
        autoDelete: false
      },
      editingToken: {
        id: '',
        name: '',
        owner: '',
        permissions: [],
        neverExpire: true,
        expirationValue: 1,
        expirationUnit: 'd',
        autoDelete: false
      },
      createdToken: {
        name: '',
        token: ''
      }
    };
  },
  computed: {
    dialogWidth() {
      return window.innerWidth > 768 ? '50%' : '90%';
    },
    userPassRules() {
      return {
        authCode: [{
          validator: (rule, value, callback) => {
            const urlReservedChars = ['%', '&', '?', '#', '/'];
            const hasReservedChar = urlReservedChars.some(char => value && value.includes(char));
            if (hasReservedChar) {
              callback(new Error(this.$t('sysSecurity.passwordUrlReserved')));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        confirmNewUserPassword: [{
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error(this.$t('sysSecurity.confirmUploadPassword')));
            } else if (value !== this.authSettings.user.authCode) {
              callback(new Error(this.$t('sysSecurity.passwordMismatch')));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }]
      };
    },
    adminPassRules() {
      return {
        confirmNewAdminPassword: [{
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error(this.$t('sysSecurity.confirmAdminPassword')));
            } else if (value !== this.authSettings.admin.adminPassword) {
              callback(new Error(this.$t('sysSecurity.passwordMismatch')));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }]
      };
    },
    accessRules() {
      const validateSessionMaxAge = (rule, value, callback) => {
        if (!Number.isInteger(value) || value < 1 || value > 3650) {
          callback(new Error(this.$t('sysSecurity.sessionMaxAgeInvalid')));
        } else {
          callback();
        }
      };
      const validateImageTransformAllowedSizes = (rule, value, callback) => {
        if (!this.accessSettings.imageTransformEnabled || !value || !value.trim()) {
          callback();
          return;
        }
        const sizes = value.split(',').map(size => size.trim().toLowerCase()).filter(Boolean);
        const valid = sizes.every(size => {
          const match = size.match(/^(auto|[1-9]\d*)x(auto|[1-9]\d*)$/);
          if (!match || match[1] === 'auto' && match[2] === 'auto') return false;
          return match.slice(1).every(dimension => dimension === 'auto' || Number(dimension) <= 4096);
        });
        if (!valid) {
          callback(new Error(this.$t('sysSecurity.imageTransformAllowedSizesInvalid')));
        } else {
          callback();
        }
      };
      return {
        userSessionMaxAge: [{
          validator: validateSessionMaxAge,
          trigger: 'change'
        }],
        adminSessionMaxAge: [{
          validator: validateSessionMaxAge,
          trigger: 'change'
        }],
        imageTransformAllowedSizes: [{
          validator: validateImageTransformAllowedSizes,
          trigger: ['blur', 'change']
        }]
      };
    },
    tokenRules() {
      return {
        name: [{
          required: true,
          message: this.$t('sysSecurity.tokenNameRequired'),
          trigger: 'blur'
        }],
        permissions: [{
          required: true,
          message: this.$t('sysSecurity.permissionsRequired'),
          trigger: 'change'
        }],
        expirationValue: [{
          validator: (rule, value, callback) => {
            if (!this.newToken.neverExpire && (!value || value <= 0)) {
              callback(new Error(this.$t('sysSecurity.validPeriodRequired')));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }]
      };
    },
    editTokenRules() {
      return {
        permissions: [{
          required: true,
          message: this.$t('sysSecurity.permissionsRequired'),
          trigger: 'change'
        }],
        expirationValue: [{
          validator: (rule, value, callback) => {
            if (!this.editingToken.neverExpire && (!value || value <= 0)) {
              callback(new Error(this.$t('sysSecurity.validPeriodRequired')));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }]
      };
    }
  },
  methods: {
    normalizeIpQuerySettings(settings = {}) {
      const ipQuery = settings.ipQuery || {};
      const customApi = ipQuery.customApi || {};
      const params = Array.isArray(customApi.params) && customApi.params.length > 0 ? customApi.params.map(param => ({
        key: param?.key || '',
        value: param?.value || ''
      })) : [{
        key: 'ip',
        value: '{ip}'
      }];
      const responseFields = Array.isArray(customApi.responseFields) ? customApi.responseFields.map(field => {
        if (typeof field === 'string') return field;
        return field?.path || '';
      }) : [];
      return {
        ...settings,
        moderate: settings.moderate || {},
        ipQuery: {
          enabled: ipQuery.enabled ?? false,
          channel: ipQuery.channel || 'customApi',
          customApi: {
            url: customApi.url || '',
            params,
            responseFields
          }
        }
      };
    },
    addIpQueryParam() {
      this.uploadSettings.ipQuery.customApi.params.push({
        key: '',
        value: ''
      });
    },
    removeIpQueryParam(index) {
      if (this.uploadSettings.ipQuery.customApi.params.length <= 1) return;
      this.uploadSettings.ipQuery.customApi.params.splice(index, 1);
    },
    addIpQueryResponseField() {
      this.uploadSettings.ipQuery.customApi.responseFields.push('');
    },
    removeIpQueryResponseField(index) {
      this.uploadSettings.ipQuery.customApi.responseFields.splice(index, 1);
    },
    moveIpQueryResponseField(index, direction) {
      const fields = this.uploadSettings.ipQuery.customApi.responseFields;
      const targetIndex = index + direction;
      if (targetIndex < 0 || targetIndex >= fields.length) return;
      const [field] = fields.splice(index, 1);
      fields.splice(targetIndex, 0, field);
    },
    handleUserPassInput() {
      if (this.authSettings.user.authCode !== this.oriUserPassword) {
        this.showUserPassConfirm = true;
      } else {
        this.showUserPassConfirm = false;
      }
    },
    handleAdminPassInput() {
      if (this.authSettings.admin.adminPassword !== this.oriAdminPassword) {
        this.showAdminPassConfirm = true;
      } else {
        this.showAdminPassConfirm = false;
      }
    },
    handleClearUserPassword(checked) {
      if (checked) {
        this.authSettings.user.authCode = '';
        this.showUserPassConfirm = false;
      }
    },
    handleClearAdminPassword(checked) {
      if (checked) {
        this.authSettings.admin.adminPassword = '';
        this.authSettings.admin.adminUsername = '';
        this.showAdminPassConfirm = false;
      }
    },
    // Token相关方法
    getPermissionText(permission) {
      const permissionMap = {
        'upload': this.$t('sysSecurity.permUpload'),
        'delete': this.$t('sysSecurity.permDelete'),
        'list': this.$t('sysSecurity.permList'),
        'manage': this.$t('sysSecurity.permManage')
      };
      return permissionMap[permission] || permission;
    },
    formatDate(dateString) {
      return new Date(dateString).toLocaleString('zh-CN');
    },
    async loadApiTokens() {
      this.tokenLoading = true;
      try {
        const response = await fetchWithAuth('/api/manage/apiTokens');
        const data = await response.json();
        this.apiTokens = data.tokens || [];
      } catch (error) {
        this.$message.error(this.$t('sysSecurity.tokenListFailed'));
      } finally {
        this.tokenLoading = false;
      }
    },
    createToken() {
      this.$refs.tokenForm.validate(async valid => {
        if (!valid) return;
        try {
          this.newToken.owner = 'admin'; // 默认所有Token归属管理员

          let expiresAt = null;
          let autoDelete = false;
          if (!this.newToken.neverExpire) {
            expiresAt = computeExpiresAt(new Date(), this.newToken.expirationValue, this.newToken.expirationUnit);
            autoDelete = this.newToken.autoDelete;
          }
          const response = await fetchWithAuth('/api/manage/apiTokens', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              name: this.newToken.name,
              owner: this.newToken.owner,
              permissions: this.newToken.permissions,
              expiresAt,
              autoDelete
            })
          });
          const data = await response.json();
          if (response.ok) {
            this.createdToken = {
              name: data.name,
              token: data.token
            };
            this.showCreateTokenDialog = false;
            this.showTokenResultDialog = true;
            this.newToken = {
              name: '',
              owner: '',
              permissions: [],
              neverExpire: true,
              expirationValue: 1,
              expirationUnit: 'd',
              autoDelete: false
            };
            await this.loadApiTokens();
            this.$message.success(this.$t('sysSecurity.tokenCreateSuccess'));
          } else {
            this.$message.error(data.error || this.$t('sysSecurity.tokenCreateFailed'));
          }
        } catch (error) {
          this.$message.error(this.$t('sysSecurity.tokenCreateFailed'));
        }
      });
    },
    editToken(token) {
      const hasExpiration = token.expiresAt !== null && token.expiresAt !== undefined;
      this.editingToken = {
        id: token.id,
        name: token.name,
        owner: token.owner,
        permissions: [...token.permissions],
        neverExpire: !hasExpiration,
        expirationValue: 1,
        expirationUnit: 'd',
        autoDelete: token.autoDelete || false
      };
      this.showEditTokenDialog = true;
    },
    updateToken() {
      this.$refs.editTokenForm.validate(async valid => {
        if (!valid) return;
        try {
          let expiresAt = null;
          let autoDelete = false;
          if (!this.editingToken.neverExpire) {
            expiresAt = computeExpiresAt(new Date(), this.editingToken.expirationValue, this.editingToken.expirationUnit);
            autoDelete = this.editingToken.autoDelete;
          }
          const response = await fetchWithAuth('/api/manage/apiTokens', {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              tokenId: this.editingToken.id,
              permissions: this.editingToken.permissions,
              expiresAt,
              autoDelete
            })
          });
          const data = await response.json();
          if (response.ok) {
            this.showEditTokenDialog = false;
            await this.loadApiTokens();
            this.$message.success(this.$t('sysSecurity.tokenUpdateSuccess'));
          } else {
            this.$message.error(data.error || this.$t('sysSecurity.tokenUpdateFailed'));
          }
        } catch (error) {
          this.$message.error(this.$t('sysSecurity.tokenUpdateFailed'));
        }
      });
    },
    async deleteToken(tokenId) {
      try {
        await this.$confirm(this.$t('sysSecurity.tokenDeleteConfirm'), this.$t('sysSecurity.tokenDeleteConfirmTitle'), {
          confirmButtonText: this.$t('sysSecurity.tokenDeleteConfirmOk'),
          cancelButtonText: this.$t('sysSecurity.tokenDeleteConfirmCancel'),
          type: 'warning'
        });
        const response = await fetchWithAuth(`/api/manage/apiTokens?id=${tokenId}`, {
          method: 'DELETE'
        });
        const data = await response.json();
        if (response.ok) {
          await this.loadApiTokens();
          this.$message.success(this.$t('sysSecurity.tokenDeleteSuccess'));
        } else {
          this.$message.error(data.error || this.$t('sysSecurity.tokenDeleteFailed'));
        }
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error(this.$t('sysSecurity.tokenDeleteFailed'));
        }
      }
    },
    async copyToken() {
      try {
        await navigator.clipboard.writeText(this.createdToken.token);
        this.$message.success(this.$t('sysSecurity.tokenCopied'));
      } catch (error) {
        this.$message.error(this.$t('sysSecurity.copyFailed'));
      }
    },
    onCreateNeverExpireChange(val) {
      if (val) {
        this.newToken.autoDelete = false;
      }
    },
    onEditNeverExpireChange(val) {
      if (val) {
        this.editingToken.autoDelete = false;
      }
    },
    getTokenStatus(expiresAt) {
      return getTokenStatus(expiresAt);
    },
    saveSettings() {
      // 所有表单的Promise数组
      let validationPromises = [];

      // 验证用户密码表单
      validationPromises.push(new Promise(resolve => {
        this.$refs.userPassForm.validate(valid => {
          resolve(valid);
        });
      }));

      // 验证管理密码表单
      validationPromises.push(new Promise(resolve => {
        this.$refs.adminPassForm.validate(valid => {
          resolve(valid);
        });
      }));

      // 验证会话安全策略表单
      validationPromises.push(new Promise(resolve => {
        this.$refs.accessForm.validate(valid => {
          resolve(valid);
        });
      }));
      validationPromises.push(new Promise(resolve => {
        this.$refs.imageTransformForm.validate(valid => {
          resolve(valid);
        });
      }));

      // 等待所有验证完成
      Promise.all(validationPromises).then(results => {
        const isValid = results.every(valid => valid);
        if (!isValid) {
          return;
        }

        // 验证会话有效期为 1-3650 的正整数
        if (this.accessSettings.userSessionMaxAge < 1 || !Number.isInteger(this.accessSettings.userSessionMaxAge) || this.accessSettings.userSessionMaxAge > 3650 || this.accessSettings.adminSessionMaxAge < 1 || !Number.isInteger(this.accessSettings.adminSessionMaxAge) || this.accessSettings.adminSessionMaxAge > 3650) {
          this.$message.error(this.$t('sysSecurity.sessionMaxAgeInvalid'));
          return;
        }
        const settings = {
          auth: this.authSettings,
          upload: this.uploadSettings,
          access: this.accessSettings
        };
        // 不保存确认密码相关字段
        delete settings.auth.user.confirmNewUserPassword;
        delete settings.auth.admin.confirmNewAdminPassword;

        // 标记清除密码
        if (this.clearUserPassword) {
          settings.auth.user._clear = true;
          settings.auth.user.authCode = '';
        }
        if (this.clearAdminPassword) {
          settings.auth.admin._clear = true;
          settings.auth.admin.adminPassword = '';
        }
        fetchWithAuth('/api/manage/sysConfig/security', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(settings)
        }).then(res => res.json()).then(data => {
          // 管理端密码变更后，当前会话已被清除，需要重新登录
          if (data.adminPasswordChanged) {
            const msg = this.$t('sysSecurity.adminPasswordChangedRelogin');
            this.$message.warning(msg);
            setTimeout(() => {
              this.$store.commit('setAdminLoggedIn', false);
              this.$router.push('/adminLogin');
            }, 1500);
            return;
          }
          this.$message.success(this.$t('sysSecurity.settingsSaved'));
          // 保存成功后重置密码字段为空（后端已处理）
          this.authSettings.user.authCode = '';
          this.authSettings.admin.adminPassword = '';
          this.oriUserPassword = '';
          this.oriAdminPassword = '';
          // 标记已有密码（如果用户刚设置了密码，且不是清除操作）
          if (settings.auth.user.authCode && !settings.auth.user._clear) {
            this.authSettings.user._hasPassword = true;
          } else if (settings.auth.user._clear) {
            this.authSettings.user._hasPassword = false;
          }
          if (settings.auth.admin.adminPassword && !settings.auth.admin._clear) {
            this.authSettings.admin._hasPassword = true;
          } else if (settings.auth.admin._clear) {
            this.authSettings.admin._hasPassword = false;
          }
          this.showUserPassConfirm = false;
          this.showAdminPassConfirm = false;
          this.clearUserPassword = false;
          this.clearAdminPassword = false;
        }).catch(() => {
          // 如果请求过程中 session 已失效导致 fetchWithAuth 跳转，忽略后续错误
        });
      });
    }
  },
  mounted() {
    this.loading = true;
    // 获取上传设置
    fetchWithAuth('/api/manage/sysConfig/security').then(response => response.json()).then(data => {
      this.authSettings = data.auth;
      this.uploadSettings = this.normalizeIpQuerySettings(data.upload);
      this.accessSettings = {
        imageTransformEnabled: false,
        imageTransformAllowedSizes: '',
        ...data.access
      };

      // 密码从后端返回为空（安全考虑），记录原始空值
      this.oriUserPassword = '';
      this.oriAdminPassword = '';
      this.authSettings.user.confirmNewUserPassword = '';
      this.authSettings.admin.confirmNewAdminPassword = '';

      // 加载API Token列表
      this.loadApiTokens();
    }).finally(() => {
      this.loading = false;
    });
  }
};